import {
  EMAIL_REGEX,
  REGEX_HAS_LOWERCASE_CHARACTER,
  REGEX_HAS_NUMBER_CHARACTER,
  REGEX_HAS_SPECIAL_CHARACTER,
  REGEX_HAS_UPPERCASE_CHARACTER
} from '../../web-components/constants/general-regex'

export const validateName = (name: string) => {
  const regex = /^[a-zA-Z ]+$/
  return regex.test(name)
}

export const validateEmail = (email: string) => {
  if (email === '') {
    return true
  }

  if (!email.length) {
    return true
  }

  const regex = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/
  return regex.test(email)
}

export const validateUrl = (url: string, domain?: string) => {
  if (url === '') {
    return true
  }
  if (domain && !url.includes(domain)) {
    return false
  }
  const regex =
    /^(https?:\/\/)?(www\.)?[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)+(?::\d{1,5})?(?:\/[a-zA-Z0-9-._?=&%+\/@]*)?$/
  return regex.test(url)
}

export const isAddressSupported = (
  address: string,
  allowedRegions?: string[]
) => {
  if (!allowedRegions?.length) {
    return true
  }
  const rgxRegion = new RegExp(allowedRegions.join('|'), 'i')
  return rgxRegion.test(address)
}

export const validateMonopolioWiggotId = (wiggotId: string): boolean => {
  const regex = /^(p[a-zA-Z0-9]{6})(_SALE|_PRESALE|_LEASE)$/

  return regex.test(wiggotId)
}

export const validateWiggotId = (wiggotId: string): boolean => {
  const regex = /^(p[a-zA-Z0-9]{6})$/

  return regex.test(wiggotId)
}

export const imgixUrlReplace = (url: string, newUrl: string) => {
  const imgixUrl = 'https://monopolio.imgix.net'
  return url?.replace(imgixUrl, newUrl) || ''
}

export const FORM_EMAIL_VALIDATIONS = {
  email: [
    (email: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email),
    'El correo no es válido'
  ]
}

export const FORM_NAME_VALIDATIONS = {
  name: [(name: string) => name.length > 0, 'El nombre es obligatorio']
}

export const FORM_PHONE_VALIDATIONS = {
  phone: [
    (phone: string) => {
      const phoneNumber = phone.replace(/[\s-]+/g, '')
      return phoneNumber.length === 10
    },
    'El número debe tener 10 dígitos'
  ]
}

export const REGEX_YOUTUBE_URL =
  /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:shorts\/|[^/]+\/[^/]+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([a-zA-Z0-9_-]{11})/

export const errorPassword = (password?: string, confirmPassword?: string) => {
  if ((password && password?.length <= 3) || !password) {
    return false
  }

  if (password?.length < 8) {
    return 'La contraseña debe tener al menos 8 caracteres'
  }

  if (!REGEX_HAS_UPPERCASE_CHARACTER.test(password)) {
    return 'La contraseña debe contener al menos una letra mayúscula'
  }

  if (!REGEX_HAS_LOWERCASE_CHARACTER.test(password)) {
    return 'La contraseña debe contener al menos una letra minúscula'
  }

  if (!REGEX_HAS_NUMBER_CHARACTER.test(password)) {
    return 'La contraseña debe contener al menos un número'
  }

  if (!REGEX_HAS_SPECIAL_CHARACTER.test(password)) {
    return 'La contraseña debe contener al menos un carácter especial'
  }

  if (password?.length > 30) {
    return 'La contraseña es muy larga'
  }

  if (confirmPassword && password !== confirmPassword) {
    return 'Las contraseñas no coinciden'
  }

  return false
}

export const errorEmail = (email?: string) => {
  if (!email || email?.length <= 3) {
    return false
  }

  return EMAIL_REGEX.test(email) ? false : 'Correo electrónico inválido'
}
